import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminCouponsPage, type AdminCouponsPageProps } from '../ui/admin/AdminCouponsPage';

export function AdminCouponsPageContainer(props: AdminCouponsPageProps) {
  return <AdminCouponsPage {...props} />;
}

export function mountAdminCouponsPage(
  container: HTMLElement,
  props: AdminCouponsPageProps
) {
  const root = createRoot(container);
  root.render(<AdminCouponsPageContainer {...props} />);
  return root;
}

export default AdminCouponsPageContainer;
